import { FetchResult } from "@apollo/client";
import { GraphQLError } from "graphql";

export default async function withRetries<T>(handler: () => Promise<FetchResult<T>>): Promise<T | undefined | null> {
    let lastErrors: readonly Error[] = [];
    for (let attempt = 0; attempt < 4; attempt += 1) {
        // eslint-disable-next-line no-await-in-loop
        const { data, errors } = await handler();
        if (!errors) {
            return data;
        }
        lastErrors = errors.map(error => new GraphQLError(error.message, error));
    }
    throw lastErrors[0];
}
